// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__KwzSi","title":"Info_title__3I92F","selects":"Info_selects__2GGm6","requiredAsterisk":"Info_requiredAsterisk__LqLN1"};